import { ReferralRequest } from "@/types";

import { axios } from "../axios.instance";

export type GetReferralsRequest = {
  perPage?: number;
  cursor?: string;
};

export type GetReferralsResponse = {
  data: ReferralRequest[];
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getReferrals = async (params: GetReferralsRequest): Promise<GetReferralsResponse> => {
  const { data } = await axios.get(`/referral-requests/my`, {
    params,
  });

  return data;
};
